import "firebase/analytics";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

import { primaryFirebaseApp, combinedFirebaseApp } from "./Auth";

export const logEvent = (name: string, payload?: object) => {
  const env = process.env.NODE_ENV;

  if (env === "production") {
    primaryFirebaseApp.analytics().logEvent(name, payload);
    combinedFirebaseApp
      .analytics()
      .logEvent(name, { ...payload, source: "marketing" });

    // Special key events, log them to LinkedIn+FB
    switch (name) {
      case "generate_lead":
        trackLinkedInConversion(17249324); // Webinar signup (GA: generate_lead)
      case "sign_up":
        trackLinkedInConversion(17249332); // Signup Redirect (GA: sign_up)
    }
  } else {
    console.log(name + ": " + JSON.stringify(payload));
  }
};

const trackLinkedInConversion = (conversionId: number) => {
  try {
    const windowObj = window as any;
    if (windowObj.lintrk) {
      windowObj.lintrk("track", { conversion_id: conversionId });
    }
  } catch (e) {
    console.error("Error in LinkedIn tracking: " + e);
  }
};

export const FirebasePageAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    const pagePath = location.pathname + location.search;
    const params = new URLSearchParams(location.search);
    const refcode = params.get("refcode");
    primaryFirebaseApp.analytics().setCurrentScreen(pagePath);

    logEvent("page_view", { path: pagePath, refcode });
    if (refcode) {
      logEvent("referred_refcode", { refcode });
    }
  }, [location]);

  return null;
};



// WEBPACK FOOTER //
// ./src/utils/Analytics.ts